import { safeDeleteSheet } from "@/lib/office-helpers";

export async function startProject14(): Promise<void> {
  await Excel.run(async (context) => {
    await safeDeleteSheet(context, "Ventas T1");
    await safeDeleteSheet(context, "Catálogo");

    const ventas = context.workbook.worksheets.add("Ventas T1");
    const catalogo = context.workbook.worksheets.add("Catálogo");

    ventas.getRange("B1:F1").merge();
    ventas.getRange("B1").values = [["OFERTA DE BICICLETA MILITAR"]];
    ventas.getRange("B1").format.font.size = 30;
    ventas.getRange("B1").format.font.bold = true;
    ventas.getRange("B1").format.horizontalAlignment = "Center";
    ventas.getRange("1:1").format.rowHeight = 72;

    catalogo.getRange("B1:F1").merge();
    catalogo.getRange("B1").values = [["OFERTA DE BICICLETA MILITAR"]];
    catalogo.getRange("B1").format.font.size = 30;
    catalogo.getRange("B1").format.font.bold = true;
    catalogo.getRange("B1").format.horizontalAlignment = "Center";
    catalogo.getRange("1:1").format.rowHeight = 72;

    const catalogoHeaders = [
      "# elemento",
      "Tipo",
      "Estilo",
      "Descripción",
      "Tamaño",
      "Precio",
    ];

    const catalogoData: (string | number)[][] = [
      [1001, "Bicicleta", "Rígida", "Campo traviesa", '15"', 1299],
      [1002, "Bicicleta", "Rígida", "Campo traviesa", '17"', 1499],
      [1003, "Bicicleta", "Rígida", "Campo traviesa", '19"', 1799],
      [1004, "Bicicleta", "Rígida", "Campo traviesa", '21"', 1899],
      [1005, "Bicicleta", "Rígida", "Campo traviesa", '23"', 2099],
      [2001, "Bicicleta", "Suspensión completa", "Sendero", '15"', 1799],
      [2002, "Bicicleta", "Suspensión completa", "Sendero", '17"', 1999],
      [2003, "Bicicleta", "Suspensión completa", "Sendero", '19"', 2199],
      [2004, "Bicicleta", "Suspensión completa", "Sendero", '21"', 2399],
      [2005, "Bicicleta", "Suspensión completa", "Sendero", '23"', 2599],
      [3001, "Bicicleta", "Carretera", "Turismo", '19"', 299],
      [3002, "Bicicleta", "Carretera", "Turismo", '21"', 499],
      [3003, "Bicicleta", "Carretera", "Turismo", '23"', 799],
      [3004, "Bicicleta", "Carretera", "Turismo", '25"', 899],
      [4001, "Triciclo", "Suspensión completa", "Sendero", '15"', 1899],
      [4002, "Triciclo", "Suspensión completa", "Sendero", '17"', 2099],
      [4003, "Triciclo", "Suspensión completa", "Sendero", '19"', 2299],
      [4004, "Triciclo", "Suspensión completa", "Sendero", '21"', 2499],
      [4005, "Triciclo", "Suspensión completa", "Sendero", '23"', 2699],
      [5001, "Triciclo", "Carretera", "Turismo", '19"', 399],
      [5002, "Triciclo", "Carretera", "Turismo", '21"', 599],
      [5003, "Triciclo", "Carretera", "Turismo", '23"', 899],
      [5004, "Triciclo", "Carretera", "Turismo", '25"', 999],
    ];

    const tablaCatalogo = catalogo.tables.add("A3:F3", true);
    tablaCatalogo.name = "Tabla13";
    tablaCatalogo.getHeaderRowRange().values = [catalogoHeaders];
    tablaCatalogo.rows.add(undefined, catalogoData);
    tablaCatalogo.style = "TableStyleMedium7";
    catalogo.getRange("F4:F26").numberFormat = Array(23).fill(["$#,##0.00"]);

    const ventasHeaders = [
      "Equipo",
      "Descripción",
      "Tamaño",
      "Cantidad",
      "Precio",
      "Total",
    ];

    const ventasData: (string | number)[][] = [
      ["Bicicleta", "", '15"', 10, 1299, 0],
      ["Bicicleta", "", '17"', 20, 1499, 0],
      ["Bicicleta", "", '19"', 20, 1799, 0],
      ["Bicicleta", "", '21"', 20, 1899, 0],
      ["Bicicleta", "", '23"', 10, 2099, 0],
      ["Bicicleta", "", '15"', 6, 1799, 0],
      ["Bicicleta", "", '17"', 6, 1999, 0],
      ["Bicicleta", "", '19"', 8, 2199, 0],
      ["Bicicleta", "", '21"', 8, 2399, 0],
      ["Bicicleta", "", '23"', 6, 2599, 0],
      ["Bicicleta", "", '19"', 12, 299, 0],
      ["Bicicleta", "", '21"', 24, 499, 0],
      ["Bicicleta", "", '23"', 24, 799, 0],
      ["Bicicleta", "", '25"', 4, 899, 0],
    ];

    const tablaVentas = ventas.tables.add("A3:F3", true);
    tablaVentas.name = "Tabla1";
    tablaVentas.getHeaderRowRange().values = [ventasHeaders];
    tablaVentas.rows.add(undefined, ventasData);
    tablaVentas.style = "TableStyleLight21";

    ventas.getRange("B4:B17").values = ventasData.map((row) => [row[1]]);
    ventas.getRange("F4:F17").formulas = Array.from({ length: 14 }, (_, i) => [
      `=D${i + 4}*E${i + 4}`,
    ]);
    ventas.getRange("E4:F17").numberFormat = Array(14).fill([
      "$#,##0.00",
      "$#,##0.00",
    ]);

    ventas.getRange("A19:B19").merge();
    ventas.getRange("A19").values = [["TOTAL DE VENTAS"]];
    ventas.getRange("A19").format.font.bold = true;
    ventas.getRange("A19").format.fill.color = "#70AD47";

    ([
      { sheet: ventas, cols: ["A:A", "B:B", "C:C", "D:D", "E:E", "F:F"], widths: [110, 170, 80, 110, 110, 120] },
      { sheet: catalogo, cols: ["A:A", "B:B", "C:C", "D:D", "E:E", "F:F"], widths: [90, 110, 160, 150, 100, 110] },
    ] as const).forEach(({ sheet, cols, widths }) => {
      cols.forEach((col, index) => {
        sheet.getRange(col).format.columnWidth = widths[index];
      });
    });

    ventas.activate();
    ventas.getRange("A1").select();

    await context.sync();
  });
}
